// src/components/ui/NavLink.tsx
// ============================================================================
// NAVIGATION LINK COMPONENT
// Client Component with CSS-driven hover/focus-visible
// Theme-locked via CSS variables from globals.css + NavLink.module.css
// No state, no wrapper divs, keyboard accessible
// ============================================================================


import React from 'react';
import Link from 'next/link';
import styles from './NavLink.module.css';

interface NavLinkProps {
  href: string;
  children: React.ReactNode;
  variant?: 'text' | 'button';
}

export const NavLink = React.forwardRef<HTMLAnchorElement, NavLinkProps>(
  ({ href, children, variant = 'text' }, ref) => {
    const className = variant === 'button' ? styles.button : styles.text;

    return (
      <Link ref={ref} href={href} className={className}>
        {children}
      </Link>
    );
  }
);

NavLink.displayName = 'NavLink';

export default NavLink;